// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/pdf_chat/first_background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --top_height: 80px;
}

ol {
    list-style: decimal;
    padding-left: 1rem;
}

ul {
    list-style: circle;
    padding-left: 2rem;
}

h1 {
    font-size: 22px;
    font-weight: 700;
    margin-top: 5px;
    margin-bottom: 5px;
}

h2 {
    font-size: 18px;
    font-weight: 700;
    margin-top: 5px;
    margin-bottom: 5px;
}

h3 {
    font-size: 15px;
    font-weight: 700;
    margin-top: 3px;
    margin-bottom: 3px;
}

.embed_code {
    font-size: 13px;
    font-weight: 400;
    padding: 10px;
    margin: 10px;
    background: #CCCCCC;

}

.landing_layout {
    width: 100vw;
    height: 100vh;
    overflow: auto;
    background: #FFFFFF;
}

.landing_first {
    width: 100%;
    height: 832px;
    background: #18145E;
    text-align: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    color: #FFFFFF;
}

.landing_second {
    width: 100%;
    height: 688px;
    text-align: center;
}

.landing_third {
    width: 100%;
    height: 832px;
    text-align: center;
    background: #F4F7FF;
    padding-top: 144px;
    display: flex;
    flex-direction: column;
}

.first_header {
    width: 100%;
    height: 80px;
    display: flex;
    text-align: start;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.09px;

    align-items: center;
    border-bottom: solid 1px #FFFFFF24;
}

.first_title {
    margin-top: 120px;
    font-size: 60px;
    font-weight: 600;
    line-height: 54px;
    letter-spacing: -0.5px;
}

.first_content {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: -0.5px;
}

.start_button {
    cursor: pointer;
    width: 122px;
    height: 44px;
    margin-top: 40px;
}

.first_login_image {
    width: 700px;
    margin-top: 40px;
    cursor: pointer;
}

.landing_second {
    width: 100%;
    height: 832px;
    text-align: center;
}

.second_header {
    position: relative;
    width: 100%;
    height: 100px;
    z-index: 3;
    /* background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 255)); */
}

.second_contents {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 50px;
}

.second_text {
    width: 500px;
    text-align: left;
    margin-top: 50px;
}

.second_contents_01 {
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.5px;
}

.second_contents_02 {
    font-size: 52px;
    font-weight: 700;
    line-height: 62.05px;
    letter-spacing: -0.5px;
}

.second_contents_03 {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-top: 40px;
    color: #666666;
}

.second_contents_03 p {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: -0.5px;
    margin-left: 35px;
    margin-top: 8px;
}

.second_contents_header {
    display: flex;
    cursor: pointer;
    align-items: center;
    margin-top: 24px;
}

.second_content_selected {
    color: #416AE4;
}

.third_header {
    /* position: relative; */
    top: 144px;
    font-size: 52px;
    font-weight: 700;
    line-height: 62.05px;
    letter-spacing: -0.5px;
}

.third_tabs {
    width: 538px;
    height: 64px;
    margin-top: 32px;
    background: #FFFFFF;
    border: solid 1px #CCCCCC;
    border-radius: 32px;
    margin: 32px auto;
    display: flex;
}

.third_tab_selected {
    width: 310px;
    height: 48px;
    background: #FF7442;
    border-radius: 24px;
    margin: 8px;
    font-size: 20px;
    font-weight: 600;
    line-height: 48px;
    letter-spacing: -0.5px;
    text-align: center;
    color: #FFFFFF;
}

.third_tab_normal {
    flex: 1 1;
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 400;
    line-height: 64px;
    letter-spacing: -0.5px;
    text-align: center;
    color: #808080;
}

.third_usage {
    display: flex;
    justify-content: center;
    gap: 40px;
}

.usage_item_layout {
    width: 340px;
    /* height: 384px; */
    border: solid 1px #CCCCCC;
    border-radius: 16px;
    background: #FFFFFF;
    padding-bottom: 30px;
}

.usage_item_type {
    width: max-content;
    min-width: 97px;
    height: 34px;
    padding: 2px 12px;
    border-radius: 8px;
    background: #FF7442;
    font-size: 16px;
    font-weight: 700;
    line-height: 34px;
    letter-spacing: -0.5px;
    text-align: center;
    color: #FFFFFF;
    margin-top: 30px;
    margin-left: 30px;
}

.usage_item_title {
    font-size: 20px;
    font-weight: 600;
    line-height: 23.87px;
    letter-spacing: -0.5px;
    text-align: left;
    margin-top: 20px;
    margin-left: 30px;
    margin-bottom: 20px;
}

.usage_item_data {
    display: flex;
    justify-content: flex-start;
    margin-left: 30px;
    margin-bottom: 13px;
    gap: 10px;
}

.usage_item_question {
    width: 210px;
    height: 58px;
    border: solid 1px #CCCCCC;
    border-radius: 5px;
    margin-left: 90px;
    margin-top: 24px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.71px;
    padding: 0px 12px;
    text-align: left;
    display: flex;
    letter-spacing: 0.05em;
    gap: 8px;
    align-items: center;
}

.usage_item_answer {
    width: 210px;
    height: 60px;
    background: #F3F0FF;
    border-radius: 5px;
    margin-left: 30px;
    margin-top: 16px;
    display: flex;
    letter-spacing: 0.05em;
    gap: 8px;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.71px;
    padding: 0px 12px;
    text-align: left;
}

.horizontal_divider {
    width: 280px;
    height: 1px;
    margin-top: 24px;
    margin-left: 30px;
    background: #CCCCCC;
}

.login_layout {
    position: relative;
    width: 100%;
    height: 100vh;
    min-width: 1208px;
    font-family: 'Roboto';
}

.login_left {
    position: absolute;
    top: 0px;
    width: 50%;
    height: 100%;
    min-width: 640px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login_right {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 50%;
    height: 100%;
    min-width: 640px;
    background: #426AE6;
    display: flex;
    justify-content: center;
    align-items: center;
}

.terms_layout {
    position: absolute;
    bottom: 40px;
    width: 202px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.5px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #FFFFFF;
}

.login_button_layout {
    width: 100%;
    height: 49px;
    margin-top: 100px;
    display: flex;
    justify-content: space-between;
}

.pdf_login_button {
    width: 110px;
    height: 49px;
    cursor: pointer;
    background-color: transparent;
    border: none;
}

.left_content {
    width: 360px;
    margin-left: -40px;

    /* background: #426AE6; */
}

.left_title_1 {
    font-family: Pretendard;
    font-size: 60px;
    font-weight: 400;
    line-height: 71.6px;
    letter-spacing: -0.5px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #000000;
}

.left_title_2 {
    font-family: Pretendard;
    font-size: 60px;
    font-weight: 700;
    line-height: 71.6px;
    letter-spacing: -0.5px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #426AE6;
}

.left_title_3 {
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 400;
    line-height: 35px;
    letter-spacing: -0.5px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 32px;
    color: #000000;
}

.right_box {
    width: 400px;
    height: 400px;
    border-radius: 60px;
    background: rgba(255, 255, 255, 0.14);
    display: flex;
    justify-content: center;
    align-items: center;
}

.right_title {
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 600;
    line-height: 28.64px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #FFFFFF;
    margin-left: 12px;
}

.top_layer {
    border-bottom: solid 1px #CCCCCC;
}

.top_contents {
    display: flex;
    justify-content: space-between;
    height: calc(var(--top_height, 60px) - 1px);
    font-size: 30px;
    font-weight: 700;
    background: #FFFFFF;
}

.top_logo {
    display: flex;
    padding: 10px 30px;
    color: #000000;
    font-size: 16px;
    font-weight: 600;
    align-items: center;
}

.top_icon {
    width: 44px;
    height: 44px;
    fill: #6b8be2;
}

.top_right {
    display: flex;
    align-items: center;
    font-size: 25px;
    font-weight: 500;
}

.top_balance {
    display: flex;
    align-items: center;
    font-size: 25px;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 6px;
}

.top_balance_text {
    padding: 5px 15px;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.top_request_button {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    font-size: 13px;
    font-weight: 700;
    color: #000000;

    padding: 10px 10px;
    border-radius: 6px;
    border: solid 1px #CCCCCC
}

.flag_icon {
    margin-left: 15px;
    width: 43px;
    border: 1px solid #CCCCCC;
}

.flag_list {
    list-style-type: none;
    padding-left: 0px;
    font-size: 15px;
    width: 140px;
}

.flag_select {
    width: 140px;
    display: inline-block;
    cursor: pointer;
    z-index: 30;
}

.flag_select .flag_selected {
    display: flex;
    justify-content: space-between;
    padding: 8px 5px;
}

.flag_select .flag_selected .flag_selected_value {
    max-width: 90px;
}

.flag_select ul {
    width: 140px;
    position: absolute;
    background: #fff;
    cursor: pointer;
    padding: 5px 0px;
    border: 1px solid #CCC;
}

.flag_select ul li {
    display: flex;
    align-items: center;
    padding: 8px 5px;
}

.flag_select ul li:hover {
    background: rgba(168, 156, 235, 0.35)
}

.top_logout {
    width: 60px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2px 20px;
    background: #FFFFFF;
    border-radius: 6px;
    cursor: pointer;
}

.top_logout_icon {
    width: 36px;
    height: 36px;
}

.request_list {
    position: absolute;
    top: 60px;
    min-width: 300px;
    background: #FFFFFF;
    border: solid 1px #CCCCCC;
    border-radius: 6px;
    list-style-type: none;
    z-index: 20;
}

.request_item {
    font-size: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 15px;
    border-bottom: solid 1px #CCCCCC;
}

.request_item:last-child {
    border: none;
}

.pdf_content_view {
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;
    height: calc(100vh - var(--top_height, 60px));
}

.v_section {
    overflow: auto;
    height: calc(100vh - var(--top_height, 60px));
    text-align: left;
}

.file_list {
    width: 300px;
    background: #F6F8F9;
}

.chat_view {
    flex: 3 1;
    background: #00FF00;
    display: flex;
    justify-content: space-evenly;
    flex-direction: row;


}

.pdf_drop_box {
    margin: 20px 30px;
    background-color: #FFFFFF;
    border: dashed 1px #CCCCCC;
    width: 240px;
    height: 100px;
    cursor: pointer;
}

.on_upload {
    border: solid 1px #CCCCCC;
}

.pdf_drop_upload {
    margin: 12px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.pdf_drop_normal {
    margin: 12px;
    display: block;
    text-align: center;
}

.drop_text {
    text-align: center;
    font-size: 14px;
    color: #666666
}

.pdf_code_popup {
    background-color: white;
    width: 700px;
}

.pdf_code_header {
    width: 620px;
    padding: 26px 40px;
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 700;
    border-bottom: solid 1px #CCCCCC;
    display: flex;
    justify-content: space-between;
}

.pdf_terms_popup {
    background-color: white;
    width: 500px;
}


.pdf_terms_header {
    width: 420px;
    padding: 26px 40px;
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 700;
    border-bottom: solid 1px #CCCCCC;
    display: flex;
    justify-content: space-between;
}

.pdf_terms_body {
    padding: 40px 32px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.5px;
    text-align: left;
    max-height: 610px;
    overflow: auto;
}

.loading_wrapper {
    display: flex;
    justify-content: center;
}

.file_upload_guide_text {
    font-size: 15px;
    margin: 20px;
}

.file_upload_progress {
    display: block;
    width: 100%;
    height: 20px;
    block-size: 40px;
}

.file_item_bg {
    position: relative;
    margin: auto;
    margin-top: 20px;
    background-color: #FFFFFF;
    border: solid 1px #CCCCCC;
    border-radius: 8px;
    width: 240px;
    height: 64px;
    cursor: pointer;
}

.file_item_info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 216px;
    margin-top: 12px;
    margin-left: 12px;
}

.file_selected {
    background-color: #426AE61A;
}

.file_error {
    background-color: #FF00002A;
}

.file_loading {
    height: 80px;
}

.file_item_inner {
    flex: 1 1;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    color: black;
}

.file_item_name {
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    width: 152px;
    color: #666666;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
}

.file_item_date {
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #959595;
}

.file_delete_button {
    padding: 5px;
    height: 20px;
    height: 20px;
}

.more_icon {
    width: 24px;
    height: 24px;
}

.more_list {
    position: absolute;
    left: 235px;
    width: 130px;
    margin-top: -20px;
    background-color: white;
    z-index: 999;
    border-radius: 8px;
    filter: drop-shadow(#AAAAAA 5px 5px 5px);
}

.more_item {
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px 12px;
    color: #666666;

}

.more_item:hover {
    background: #CCCCCC;
}

.chat_layout {
    flex: 1 1;
    background: #FFFFFF;
}

.referance_layout {
    width: 740px;
    background: #FFFFFF;
    border-left: solid 1px #cccccc;
}

.referance_closed {
    width: 0px;
    transition-property: width;
    transition-duration: 200ms;
}

.referance_opened {
    width: 400px;
    transition-property: width;
    transition-duration: 200ms;
}

.file_chat_content {
    background-color: #FFFFFF;
    padding: 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.file_chat_layout {
    flex: 1 1;
    overflow-y: auto;
}

.bot_icon_layout {
    display: flex;
    margin-left: 20px;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.bot_icon {
    width: 34px;
    height: 34px;
}

.user_icon_layout {
    display: flex;
    justify-content: start;
    max-width: calc(100% - 40px);
    margin-top: 35px;
    margin-left: 25px;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #000000;
}

.user_icon {
    width: 34px;
    height: 34px;
}

.pdf_bot_text {
    max-width: calc(100% - 40px);
    margin-left: 5px;
    margin-top: 3px;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #666666
}

.pdf_bot_text .textbox {
    margin-left: 20px;
    padding: none;
    font-size: 14px;
    /* background-color: #ddd; */
}

.textbox strong {
    font-size: 14px;
    font-weight: 600;
}

.textbox table {
    border: 2px solid #CCC;
    margin: 2px;
}

.textbox table td {
    border: 1px solid #CCC;
    padding: 2px;
}

.textbox table th {
    border: 2px solid #CCC;
    padding: 2px;
}


.pdf_user_text {
    display: flex;
    flex-direction: row;
    max-width: calc(100% - 50px);
    margin-left: 5px;
    margin-top: 3px;
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #666666
}

.pdf_user_text .textbox {
    margin-left: 20px;
    padding: none;
    font-size: 14px;
}

/* .pdf_bot_text .textbox::before {
    left: -15px;    
    content: "◀";
    color: #ddd;
} */
.pdf_knowledge_layout {
    position: relative;
    display: flex;
    justify-content: end;
    margin-right: 20px;
}

.pdf_knowledge_item_layout {
    display: flex;
    align-items: center;
    gap: 8px;
}

.pdf_knowledge {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 71px;
    height: 36px;
    margin-top: 7px;
    margin-left: 10px;
    color: #FFFFFF;
    background: #426AE6;
    cursor: pointer;
    font-size: 13px;
    border-radius: 4px;
}

.pdf_knowledge_item {
    width: 40px;
    height: 36px;
    border-radius: 4px;
    margin-top: 7px;
    align-items: center;
    text-align: center;
    line-height: 36px;
    color: #FFFFFF;
    font-size: 13px;
    background: #426AE6;
    cursor: pointer;
}

.box {
    outline: medium solid #FF0000;
}

.item_1 {
    background: #e9d8a6;
    color: #000000;
}

.item_2 {
    background: #005f73;
}

.item_3 {
    background: #bb3e03;
}

.pdf_chat_help {
    font-size: 24px;
    font-weight: 700;
    color: #000000;
    height: calc(100vh - var(--top_height, 60px));
    display: flex;
    justify-content: center;
    align-items: center;
}

.pdf_chat_guide {
    font-size: 24px;
    font-weight: 700;
    color: #000000;
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px;
    padding-top: 200px;
}

.pdf_chat_prompt {
    text-align: center;
}

.pdf_chat_input_box {
    height: 52px;
    width: calc(100% - 40px);
    background: #F7F9FA;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    border: none;
    margin: 20px;
}

.pdf_chat_input_box.select {
    box-shadow: 0 0 0 2px #000000 inset;
}

.pdf_chat_input_box_help {
    width: 600px;
    margin-top: 40px;
}

.pdf_chat_input {
    width: 100%;
    height: 100%;
    background: none;
    border: none;
    outline: none;
    padding-left: 20px;
    padding-right: 60px;
}

.pdf_send_box {
    right: 20px;
    height: 50px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pdf_send_button {
    width: 24px;
    height: 24px;
}

.pdf_chat_knowledge_content {
    margin: 20px;
    padding: 10px;
    background: #F6F8F9;
    border: solid 1px #CCCCCC;
    color: #666666;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
}

.reference_close_icon {
    width: 36px;
    height: 36px;
    margin-top: 20px;
    margin-left: 20px;
}

.reference_title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 20px;
    margin-left: 20px;
}

.loading_progress_bar {
    position: relative;
    width: 216px;
    height: 8px;
    border-radius: 30px;
    background-color: #bbd0ff;
    overflow: hidden;
}

.loading_progress_bar_gauge {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 8px;
    border-radius: 30px;
    background-color: #426AE6;
}

.run_gauge_animation {
    animation-name: loading_bar_animation;
    animation-duration: 3000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

.pdf_file_info {
    align-items: center;
    margin: 20px;
    padding: 20px;
    background: #F6F8F9;
    font-size: 14px;
    color: #666666;
}

.pdf_file_name {
    font-size: 14px;
    color: #000000;
    font-weight: 600;
}

.pdf_summary {
    font-size: 14px;
    color: #666666;
}

.pdf_summary p {
    margin-top: 5px;
}

.pdf_summary ul>li {
    margin-top: 5px;
    padding: 10px;
    cursor: pointer;
}

.pdf_summary ol>li {
    background: #FFFFFF;
    margin-top: 10px;
    padding: 10px;
    border-radius: 6px;
    border: solid 1px #CCCCCC;
    cursor: pointer;
}

.external_layout {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background: transparent;
}

.chat_header_layout {
    display: block;
    width: 400px;
    height: 120px;

}

.chat_center_layout {
    margin-top: 24px;
    padding-top: 24px;
    flex: 1 1;
    background: #F7F9FA;
    overflow: auto;
}

.chat_input_layout {
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 134px;
}
.chat_input_center {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
}

.chat_input_box {
    display: flex;
    width: 325px;
    height: 52px;
    background: #F7F9FA;
}

.chat_input_box input {
    flex: 1 1;
    background: transparent;
    outline: none;
    border: none;
    padding-left: 15px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
}

.chat_input_send_icon {
    width: 24px;
    height: 24px;
    margin-top: 14px;
    margin-right: 14px;
}

.chat_copyright {
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    color: #666666;
    margin-top: 16px;
}

.chat_bot_layout {
    text-align: start;
    width: 100%;
}

.chat_bot_text {
    margin-left: 24px;
    margin-top: 10px;
    background: #4258E51F;
    position: relative;
    display: inline-block;
    max-width: calc(100% - 97px);
    border-radius: 0px 8px 8px 8px;
    color: #000000;
}

.chat_user_layout {
    display: flex;
    flex-direction: row-reverse;
}

.chat_user_text {
    margin-top: 10px;
    margin-right: 24px;
    background: #4258E5;
    position: relative;
    display: inline-block;
    max-width: calc(100% - 97px);
    border-radius: 8px 0px 8px 8px;
    color: #FFFFFF;
}

.chat_textbox {
    font-size: 14px;
    padding: 12px;
    text-align: start;
}

.chat_textbox strong {
    font-size: 14px;
    font-weight: 700;
}

.pdf_chat_time {
    margin: 10px 24px;
    font-size: 12px;
    color: #666666;
}

.loading_area {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 100%;
    height: 100%;
    text-align: center;
}

.loading_area>div {
    width: 10px;
    height: 10px;
    background-color: black;
    border-radius: 100%;
    display: inline-block;
    animation: loading 1.5s infinite ease-in-out both;
}

.loading_area .dot2 {
    animation-delay: 0.1s;
}

.loading_area .dot3 {
    animation-delay: 0.2s;
}

.chat_close_button {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 32px;
    height: 32px;
}

.chat_title {
    margin-top: 30px;
}

.chat_bold_text {
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.09px;
}

.pdf_viewer_layout {
    display: flex;
    overflow: hidden;
    height: calc(100vh - var(--top_height, 60px))
}

.pdf_viewer_thumbnail_layout {
    width: 130px;
    overflow-y: auto;
}

.pdf_viewer_thumbnail_selected {
    background: #FF0000;
}

.pdf_viewer_item {
    margin: 0px 0px;
    border: solid 1px #EEEEEE;
    box-shadow: #DDDDDD;
}

.pdf_viewer_guide {
    margin: 20px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
}

.pdf_viewer_page_layout {
    overflow-y: auto;
    height: calc(100vh - var(--top_height, 60px) - 30px)
}

.external_chat_button {
    width: 44px;
    height: 44px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    background: linear-gradient(135deg, #ACC0FF 0%, #426AE6 100%);
    border-radius: 5px;
}

.external_chat_view {
    display: flex;
    flex-direction: column;
    width: 400px;
    height: 834px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    border: solid 1px #CCCCCC;

}

.external_chat_view_appear {
    height: 834px;
    border: solid 1px #CCCCCC;
    animation-name: chat_view_showing;
    animation-duration: 200ms;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
}

.chat_view_flag_icon {
    width: 37px;
    border: 1px solid #CCCCCC;
}
.chat_view_flag_select {
    width: 37px;
    display: inline-block;
    cursor: pointer;
    z-index: 30;
}

.chat_view_flag_list {
    position: absolute;
    top: 470px;
    left: 8px;
    list-style-type: none;
    padding-left: 0px;
    font-size: 15px;
    background-color: transparent;
}

.flag_chat_view_flag_selectselect .flag_selected .flag_selected_value {
    max-width: 90px;
}

.chat_view_flag_select ul {
    width: 50px;
    position: absolute;
    background: #fff;
    cursor: pointer;
    padding: 0px;
    border: 1px solid #CCC;
}

.chat_view_flag_select ul li {
    display: flex;
    align-items: center;
    padding: 8px 5px;
}

.chat_view_flag_select ul li:hover {
    background: rgba(168, 156, 235, 0.35)
}

@keyframes loading_bar_animation {
    0% {
        width: 0;
        opacity: 1;
    }

    100% {
        width: 100%;
        opacity: 1;
    }
}

@keyframes chat_view_showing {
    from {
        width: 0;
        height: 0;
        opacity: 0;
    }

    to {
        width: 400px;
        height: 834px;
        opacity: 1;
    }
}

@keyframes loading {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.0);
    }

    100% {
        transform: scale(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/pdfchat/pdfchat.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yDAAgE;IAChE,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;;IAEpB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,UAAU;IACV,8FAA8F;AAClG;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;;IAEd,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;;;AAGvB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;;;;GAIG;AACH;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6CAA6C;IAC7C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;;AAEjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,SAAO;IACP,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,6DAA6D;IAC7D,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iCAAiC;IACjC,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;QACT,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[":root {\n    --top_height: 80px;\n}\n\nol {\n    list-style: decimal;\n    padding-left: 1rem;\n}\n\nul {\n    list-style: circle;\n    padding-left: 2rem;\n}\n\nh1 {\n    font-size: 22px;\n    font-weight: 700;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\nh2 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\nh3 {\n    font-size: 15px;\n    font-weight: 700;\n    margin-top: 3px;\n    margin-bottom: 3px;\n}\n\n.embed_code {\n    font-size: 13px;\n    font-weight: 400;\n    padding: 10px;\n    margin: 10px;\n    background: #CCCCCC;\n\n}\n\n.landing_layout {\n    width: 100vw;\n    height: 100vh;\n    overflow: auto;\n    background: #FFFFFF;\n}\n\n.landing_first {\n    width: 100%;\n    height: 832px;\n    background: #18145E;\n    text-align: center;\n    background-image: url(\"../assets/pdf_chat/first_background.svg\");\n    background-size: cover;\n    color: #FFFFFF;\n}\n\n.landing_second {\n    width: 100%;\n    height: 688px;\n    text-align: center;\n}\n\n.landing_third {\n    width: 100%;\n    height: 832px;\n    text-align: center;\n    background: #F4F7FF;\n    padding-top: 144px;\n    display: flex;\n    flex-direction: column;\n}\n\n.first_header {\n    width: 100%;\n    height: 80px;\n    display: flex;\n    text-align: start;\n    font-family: Pretendard;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19.09px;\n\n    align-items: center;\n    border-bottom: solid 1px #FFFFFF24;\n}\n\n.first_title {\n    margin-top: 120px;\n    font-size: 60px;\n    font-weight: 600;\n    line-height: 54px;\n    letter-spacing: -0.5px;\n}\n\n.first_content {\n    margin-top: 30px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 32px;\n    letter-spacing: -0.5px;\n}\n\n.start_button {\n    cursor: pointer;\n    width: 122px;\n    height: 44px;\n    margin-top: 40px;\n}\n\n.first_login_image {\n    width: 700px;\n    margin-top: 40px;\n    cursor: pointer;\n}\n\n.landing_second {\n    width: 100%;\n    height: 832px;\n    text-align: center;\n}\n\n.second_header {\n    position: relative;\n    width: 100%;\n    height: 100px;\n    z-index: 3;\n    /* background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 255)); */\n}\n\n.second_contents {\n    display: flex;\n    justify-content: center;\n    gap: 30px;\n    margin-top: 50px;\n}\n\n.second_text {\n    width: 500px;\n    text-align: left;\n    margin-top: 50px;\n}\n\n.second_contents_01 {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 30px;\n    letter-spacing: -0.5px;\n}\n\n.second_contents_02 {\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 62.05px;\n    letter-spacing: -0.5px;\n}\n\n.second_contents_03 {\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 28px;\n    letter-spacing: -0.5px;\n    margin-top: 40px;\n    color: #666666;\n}\n\n.second_contents_03 p {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    letter-spacing: -0.5px;\n    margin-left: 35px;\n    margin-top: 8px;\n}\n\n.second_contents_header {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    margin-top: 24px;\n}\n\n.second_content_selected {\n    color: #416AE4;\n}\n\n.third_header {\n    /* position: relative; */\n    top: 144px;\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 62.05px;\n    letter-spacing: -0.5px;\n}\n\n.third_tabs {\n    width: 538px;\n    height: 64px;\n    margin-top: 32px;\n    background: #FFFFFF;\n    border: solid 1px #CCCCCC;\n    border-radius: 32px;\n    margin: 32px auto;\n    display: flex;\n}\n\n.third_tab_selected {\n    width: 310px;\n    height: 48px;\n    background: #FF7442;\n    border-radius: 24px;\n    margin: 8px;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 48px;\n    letter-spacing: -0.5px;\n    text-align: center;\n    color: #FFFFFF;\n}\n\n.third_tab_normal {\n    flex: 1;\n    font-family: Pretendard;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 64px;\n    letter-spacing: -0.5px;\n    text-align: center;\n    color: #808080;\n}\n\n.third_usage {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n}\n\n.usage_item_layout {\n    width: 340px;\n    /* height: 384px; */\n    border: solid 1px #CCCCCC;\n    border-radius: 16px;\n    background: #FFFFFF;\n    padding-bottom: 30px;\n}\n\n.usage_item_type {\n    width: max-content;\n    min-width: 97px;\n    height: 34px;\n    padding: 2px 12px;\n    border-radius: 8px;\n    background: #FF7442;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 34px;\n    letter-spacing: -0.5px;\n    text-align: center;\n    color: #FFFFFF;\n    margin-top: 30px;\n    margin-left: 30px;\n}\n\n.usage_item_title {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 23.87px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    margin-top: 20px;\n    margin-left: 30px;\n    margin-bottom: 20px;\n}\n\n.usage_item_data {\n    display: flex;\n    justify-content: flex-start;\n    margin-left: 30px;\n    margin-bottom: 13px;\n    gap: 10px;\n}\n\n.usage_item_question {\n    width: 210px;\n    height: 58px;\n    border: solid 1px #CCCCCC;\n    border-radius: 5px;\n    margin-left: 90px;\n    margin-top: 24px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.71px;\n    padding: 0px 12px;\n    text-align: left;\n    display: flex;\n    letter-spacing: 0.05em;\n    gap: 8px;\n    align-items: center;\n}\n\n.usage_item_answer {\n    width: 210px;\n    height: 60px;\n    background: #F3F0FF;\n    border-radius: 5px;\n    margin-left: 30px;\n    margin-top: 16px;\n    display: flex;\n    letter-spacing: 0.05em;\n    gap: 8px;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.71px;\n    padding: 0px 12px;\n    text-align: left;\n}\n\n.horizontal_divider {\n    width: 280px;\n    height: 1px;\n    margin-top: 24px;\n    margin-left: 30px;\n    background: #CCCCCC;\n}\n\n.login_layout {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    min-width: 1208px;\n    font-family: 'Roboto';\n}\n\n.login_left {\n    position: absolute;\n    top: 0px;\n    width: 50%;\n    height: 100%;\n    min-width: 640px;\n    background: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.login_right {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 50%;\n    height: 100%;\n    min-width: 640px;\n    background: #426AE6;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.terms_layout {\n    position: absolute;\n    bottom: 40px;\n    width: 202px;\n    height: 20px;\n    display: flex;\n    justify-content: space-between;\n    font-family: Pretendard;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: #FFFFFF;\n}\n\n.login_button_layout {\n    width: 100%;\n    height: 49px;\n    margin-top: 100px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.pdf_login_button {\n    width: 110px;\n    height: 49px;\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n}\n\n.left_content {\n    width: 360px;\n    margin-left: -40px;\n\n    /* background: #426AE6; */\n}\n\n.left_title_1 {\n    font-family: Pretendard;\n    font-size: 60px;\n    font-weight: 400;\n    line-height: 71.6px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: #000000;\n}\n\n.left_title_2 {\n    font-family: Pretendard;\n    font-size: 60px;\n    font-weight: 700;\n    line-height: 71.6px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: #426AE6;\n}\n\n.left_title_3 {\n    font-family: Pretendard;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 35px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    margin-top: 32px;\n    color: #000000;\n}\n\n.right_box {\n    width: 400px;\n    height: 400px;\n    border-radius: 60px;\n    background: rgba(255, 255, 255, 0.14);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.right_title {\n    font-family: Pretendard;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 28.64px;\n    text-align: left;\n    text-underline-position: from-font;\n    text-decoration-skip-ink: none;\n    color: #FFFFFF;\n    margin-left: 12px;\n}\n\n.top_layer {\n    border-bottom: solid 1px #CCCCCC;\n}\n\n.top_contents {\n    display: flex;\n    justify-content: space-between;\n    height: calc(var(--top_height, 60px) - 1px);\n    font-size: 30px;\n    font-weight: 700;\n    background: #FFFFFF;\n}\n\n.top_logo {\n    display: flex;\n    padding: 10px 30px;\n    color: #000000;\n    font-size: 16px;\n    font-weight: 600;\n    align-items: center;\n}\n\n.top_icon {\n    width: 44px;\n    height: 44px;\n    fill: #6b8be2;\n}\n\n.top_right {\n    display: flex;\n    align-items: center;\n    font-size: 25px;\n    font-weight: 500;\n}\n\n.top_balance {\n    display: flex;\n    align-items: center;\n    font-size: 25px;\n    justify-content: space-between;\n    background: #FFFFFF;\n    border-radius: 6px;\n}\n\n.top_balance_text {\n    padding: 5px 15px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.top_request_button {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    background: #FFFFFF;\n    font-size: 13px;\n    font-weight: 700;\n    color: #000000;\n\n    padding: 10px 10px;\n    border-radius: 6px;\n    border: solid 1px #CCCCCC\n}\n\n.flag_icon {\n    margin-left: 15px;\n    width: 43px;\n    border: 1px solid #CCCCCC;\n}\n\n.flag_list {\n    list-style-type: none;\n    padding-left: 0px;\n    font-size: 15px;\n    width: 140px;\n}\n\n.flag_select {\n    width: 140px;\n    display: inline-block;\n    cursor: pointer;\n    z-index: 30;\n}\n\n.flag_select .flag_selected {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 5px;\n}\n\n.flag_select .flag_selected .flag_selected_value {\n    max-width: 90px;\n}\n\n.flag_select ul {\n    width: 140px;\n    position: absolute;\n    background: #fff;\n    cursor: pointer;\n    padding: 5px 0px;\n    border: 1px solid #CCC;\n}\n\n.flag_select ul li {\n    display: flex;\n    align-items: center;\n    padding: 8px 5px;\n}\n\n.flag_select ul li:hover {\n    background: rgba(168, 156, 235, 0.35)\n}\n\n.top_logout {\n    width: 60px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 2px 20px;\n    background: #FFFFFF;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.top_logout_icon {\n    width: 36px;\n    height: 36px;\n}\n\n.request_list {\n    position: absolute;\n    top: 60px;\n    min-width: 300px;\n    background: #FFFFFF;\n    border: solid 1px #CCCCCC;\n    border-radius: 6px;\n    list-style-type: none;\n    z-index: 20;\n}\n\n.request_item {\n    font-size: 12px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 10px 15px;\n    border-bottom: solid 1px #CCCCCC;\n}\n\n.request_item:last-child {\n    border: none;\n}\n\n.pdf_content_view {\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n    height: calc(100vh - var(--top_height, 60px));\n}\n\n.v_section {\n    overflow: auto;\n    height: calc(100vh - var(--top_height, 60px));\n    text-align: left;\n}\n\n.file_list {\n    width: 300px;\n    background: #F6F8F9;\n}\n\n.chat_view {\n    flex: 3;\n    background: #00FF00;\n    display: flex;\n    justify-content: space-evenly;\n    flex-direction: row;\n\n\n}\n\n.pdf_drop_box {\n    margin: 20px 30px;\n    background-color: #FFFFFF;\n    border: dashed 1px #CCCCCC;\n    width: 240px;\n    height: 100px;\n    cursor: pointer;\n}\n\n.on_upload {\n    border: solid 1px #CCCCCC;\n}\n\n.pdf_drop_upload {\n    margin: 12px;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n}\n\n.pdf_drop_normal {\n    margin: 12px;\n    display: block;\n    text-align: center;\n}\n\n.drop_text {\n    text-align: center;\n    font-size: 14px;\n    color: #666666\n}\n\n.pdf_code_popup {\n    background-color: white;\n    width: 700px;\n}\n\n.pdf_code_header {\n    width: 620px;\n    padding: 26px 40px;\n    font-family: Pretendard;\n    font-size: 24px;\n    font-weight: 700;\n    border-bottom: solid 1px #CCCCCC;\n    display: flex;\n    justify-content: space-between;\n}\n\n.pdf_terms_popup {\n    background-color: white;\n    width: 500px;\n}\n\n\n.pdf_terms_header {\n    width: 420px;\n    padding: 26px 40px;\n    font-family: Pretendard;\n    font-size: 24px;\n    font-weight: 700;\n    border-bottom: solid 1px #CCCCCC;\n    display: flex;\n    justify-content: space-between;\n}\n\n.pdf_terms_body {\n    padding: 40px 32px;\n    font-family: Pretendard;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.5px;\n    text-align: left;\n    max-height: 610px;\n    overflow: auto;\n}\n\n.loading_wrapper {\n    display: flex;\n    justify-content: center;\n}\n\n.file_upload_guide_text {\n    font-size: 15px;\n    margin: 20px;\n}\n\n.file_upload_progress {\n    display: block;\n    width: 100%;\n    height: 20px;\n    block-size: 40px;\n}\n\n.file_item_bg {\n    position: relative;\n    margin: auto;\n    margin-top: 20px;\n    background-color: #FFFFFF;\n    border: solid 1px #CCCCCC;\n    border-radius: 8px;\n    width: 240px;\n    height: 64px;\n    cursor: pointer;\n}\n\n.file_item_info {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    width: 216px;\n    margin-top: 12px;\n    margin-left: 12px;\n}\n\n.file_selected {\n    background-color: #426AE61A;\n}\n\n.file_error {\n    background-color: #FF00002A;\n}\n\n.file_loading {\n    height: 80px;\n}\n\n.file_item_inner {\n    flex: 1;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 500;\n    color: black;\n}\n\n.file_item_name {\n    font-family: Pretendard;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 20px;\n    width: 152px;\n    color: #666666;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: break-all;\n}\n\n.file_item_date {\n    font-family: Pretendard;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #959595;\n}\n\n.file_delete_button {\n    padding: 5px;\n    height: 20px;\n    height: 20px;\n}\n\n.more_icon {\n    width: 24px;\n    height: 24px;\n}\n\n.more_list {\n    position: absolute;\n    left: 235px;\n    width: 130px;\n    margin-top: -20px;\n    background-color: white;\n    z-index: 999;\n    border-radius: 8px;\n    filter: drop-shadow(#AAAAAA 5px 5px 5px);\n}\n\n.more_item {\n    font-family: Pretendard;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 20px;\n    padding: 10px 12px;\n    color: #666666;\n\n}\n\n.more_item:hover {\n    background: #CCCCCC;\n}\n\n.chat_layout {\n    flex: 1;\n    background: #FFFFFF;\n}\n\n.referance_layout {\n    width: 740px;\n    background: #FFFFFF;\n    border-left: solid 1px #cccccc;\n}\n\n.referance_closed {\n    width: 0px;\n    transition-property: width;\n    transition-duration: 200ms;\n}\n\n.referance_opened {\n    width: 400px;\n    transition-property: width;\n    transition-duration: 200ms;\n}\n\n.file_chat_content {\n    background-color: #FFFFFF;\n    padding: 0px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.file_chat_layout {\n    flex: 1;\n    overflow-y: auto;\n}\n\n.bot_icon_layout {\n    display: flex;\n    margin-left: 20px;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.bot_icon {\n    width: 34px;\n    height: 34px;\n}\n\n.user_icon_layout {\n    display: flex;\n    justify-content: start;\n    max-width: calc(100% - 40px);\n    margin-top: 35px;\n    margin-left: 25px;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: #000000;\n}\n\n.user_icon {\n    width: 34px;\n    height: 34px;\n}\n\n.pdf_bot_text {\n    max-width: calc(100% - 40px);\n    margin-left: 5px;\n    margin-top: 3px;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #666666\n}\n\n.pdf_bot_text .textbox {\n    margin-left: 20px;\n    padding: none;\n    font-size: 14px;\n    /* background-color: #ddd; */\n}\n\n.textbox strong {\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.textbox table {\n    border: 2px solid #CCC;\n    margin: 2px;\n}\n\n.textbox table td {\n    border: 1px solid #CCC;\n    padding: 2px;\n}\n\n.textbox table th {\n    border: 2px solid #CCC;\n    padding: 2px;\n}\n\n\n.pdf_user_text {\n    display: flex;\n    flex-direction: row;\n    max-width: calc(100% - 50px);\n    margin-left: 5px;\n    margin-top: 3px;\n    justify-content: flex-start;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #666666\n}\n\n.pdf_user_text .textbox {\n    margin-left: 20px;\n    padding: none;\n    font-size: 14px;\n}\n\n/* .pdf_bot_text .textbox::before {\n    left: -15px;    \n    content: \"◀\";\n    color: #ddd;\n} */\n.pdf_knowledge_layout {\n    position: relative;\n    display: flex;\n    justify-content: end;\n    margin-right: 20px;\n}\n\n.pdf_knowledge_item_layout {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.pdf_knowledge {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 71px;\n    height: 36px;\n    margin-top: 7px;\n    margin-left: 10px;\n    color: #FFFFFF;\n    background: #426AE6;\n    cursor: pointer;\n    font-size: 13px;\n    border-radius: 4px;\n}\n\n.pdf_knowledge_item {\n    width: 40px;\n    height: 36px;\n    border-radius: 4px;\n    margin-top: 7px;\n    align-items: center;\n    text-align: center;\n    line-height: 36px;\n    color: #FFFFFF;\n    font-size: 13px;\n    background: #426AE6;\n    cursor: pointer;\n}\n\n.box {\n    outline: medium solid #FF0000;\n}\n\n.item_1 {\n    background: #e9d8a6;\n    color: #000000;\n}\n\n.item_2 {\n    background: #005f73;\n}\n\n.item_3 {\n    background: #bb3e03;\n}\n\n.pdf_chat_help {\n    font-size: 24px;\n    font-weight: 700;\n    color: #000000;\n    height: calc(100vh - var(--top_height, 60px));\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pdf_chat_guide {\n    font-size: 24px;\n    font-weight: 700;\n    color: #000000;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 15px;\n    padding-top: 200px;\n}\n\n.pdf_chat_prompt {\n    text-align: center;\n}\n\n.pdf_chat_input_box {\n    height: 52px;\n    width: calc(100% - 40px);\n    background: #F7F9FA;\n    display: flex;\n    /* justify-content: space-between; */\n    align-items: center;\n    border: none;\n    margin: 20px;\n}\n\n.pdf_chat_input_box.select {\n    box-shadow: 0 0 0 2px #000000 inset;\n}\n\n.pdf_chat_input_box_help {\n    width: 600px;\n    margin-top: 40px;\n}\n\n.pdf_chat_input {\n    width: 100%;\n    height: 100%;\n    background: none;\n    border: none;\n    outline: none;\n    padding-left: 20px;\n    padding-right: 60px;\n}\n\n.pdf_send_box {\n    right: 20px;\n    height: 50px;\n    width: 60px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pdf_send_button {\n    width: 24px;\n    height: 24px;\n}\n\n.pdf_chat_knowledge_content {\n    margin: 20px;\n    padding: 10px;\n    background: #F6F8F9;\n    border: solid 1px #CCCCCC;\n    color: #666666;\n    font-size: 13px;\n    font-weight: 400;\n    text-align: left;\n}\n\n.reference_close_icon {\n    width: 36px;\n    height: 36px;\n    margin-top: 20px;\n    margin-left: 20px;\n}\n\n.reference_title {\n    font-size: 16px;\n    font-weight: 600;\n    margin-top: 20px;\n    margin-left: 20px;\n}\n\n.loading_progress_bar {\n    position: relative;\n    width: 216px;\n    height: 8px;\n    border-radius: 30px;\n    background-color: #bbd0ff;\n    overflow: hidden;\n}\n\n.loading_progress_bar_gauge {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 8px;\n    border-radius: 30px;\n    background-color: #426AE6;\n}\n\n.run_gauge_animation {\n    animation-name: loading_bar_animation;\n    animation-duration: 3000ms;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n}\n\n.pdf_file_info {\n    align-items: center;\n    margin: 20px;\n    padding: 20px;\n    background: #F6F8F9;\n    font-size: 14px;\n    color: #666666;\n}\n\n.pdf_file_name {\n    font-size: 14px;\n    color: #000000;\n    font-weight: 600;\n}\n\n.pdf_summary {\n    font-size: 14px;\n    color: #666666;\n}\n\n.pdf_summary p {\n    margin-top: 5px;\n}\n\n.pdf_summary ul>li {\n    margin-top: 5px;\n    padding: 10px;\n    cursor: pointer;\n}\n\n.pdf_summary ol>li {\n    background: #FFFFFF;\n    margin-top: 10px;\n    padding: 10px;\n    border-radius: 6px;\n    border: solid 1px #CCCCCC;\n    cursor: pointer;\n}\n\n.external_layout {\n    position: absolute;\n    width: 100vw;\n    height: 100vh;\n    background: transparent;\n}\n\n.chat_header_layout {\n    display: block;\n    width: 400px;\n    height: 120px;\n\n}\n\n.chat_center_layout {\n    margin-top: 24px;\n    padding-top: 24px;\n    flex: 1;\n    background: #F7F9FA;\n    overflow: auto;\n}\n\n.chat_input_layout {\n    background: #FFFFFF;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 400px;\n    height: 134px;\n}\n.chat_input_center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n}\n\n.chat_input_box {\n    display: flex;\n    width: 325px;\n    height: 52px;\n    background: #F7F9FA;\n}\n\n.chat_input_box input {\n    flex: 1;\n    background: transparent;\n    outline: none;\n    border: none;\n    padding-left: 15px;\n    font-family: Pretendard;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n}\n\n.chat_input_send_icon {\n    width: 24px;\n    height: 24px;\n    margin-top: 14px;\n    margin-right: 14px;\n}\n\n.chat_copyright {\n    font-family: Pretendard;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    text-align: center;\n    color: #666666;\n    margin-top: 16px;\n}\n\n.chat_bot_layout {\n    text-align: start;\n    width: 100%;\n}\n\n.chat_bot_text {\n    margin-left: 24px;\n    margin-top: 10px;\n    background: #4258E51F;\n    position: relative;\n    display: inline-block;\n    max-width: calc(100% - 97px);\n    border-radius: 0px 8px 8px 8px;\n    color: #000000;\n}\n\n.chat_user_layout {\n    display: flex;\n    flex-direction: row-reverse;\n}\n\n.chat_user_text {\n    margin-top: 10px;\n    margin-right: 24px;\n    background: #4258E5;\n    position: relative;\n    display: inline-block;\n    max-width: calc(100% - 97px);\n    border-radius: 8px 0px 8px 8px;\n    color: #FFFFFF;\n}\n\n.chat_textbox {\n    font-size: 14px;\n    padding: 12px;\n    text-align: start;\n}\n\n.chat_textbox strong {\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.pdf_chat_time {\n    margin: 10px 24px;\n    font-size: 12px;\n    color: #666666;\n}\n\n.loading_area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n}\n\n.loading_area>div {\n    width: 10px;\n    height: 10px;\n    background-color: black;\n    border-radius: 100%;\n    display: inline-block;\n    animation: loading 1.5s infinite ease-in-out both;\n}\n\n.loading_area .dot2 {\n    animation-delay: 0.1s;\n}\n\n.loading_area .dot3 {\n    animation-delay: 0.2s;\n}\n\n.chat_close_button {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    width: 32px;\n    height: 32px;\n}\n\n.chat_title {\n    margin-top: 30px;\n}\n\n.chat_bold_text {\n    font-family: Pretendard;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 19.09px;\n}\n\n.pdf_viewer_layout {\n    display: flex;\n    overflow: hidden;\n    height: calc(100vh - var(--top_height, 60px))\n}\n\n.pdf_viewer_thumbnail_layout {\n    width: 130px;\n    overflow-y: auto;\n}\n\n.pdf_viewer_thumbnail_selected {\n    background: #FF0000;\n}\n\n.pdf_viewer_item {\n    margin: 0px 0px;\n    border: solid 1px #EEEEEE;\n    box-shadow: #DDDDDD;\n}\n\n.pdf_viewer_guide {\n    margin: 20px;\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.pdf_viewer_page_layout {\n    overflow-y: auto;\n    height: calc(100vh - var(--top_height, 60px) - 30px)\n}\n\n.external_chat_button {\n    width: 44px;\n    height: 44px;\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    background: linear-gradient(135deg, #ACC0FF 0%, #426AE6 100%);\n    border-radius: 5px;\n}\n\n.external_chat_view {\n    display: flex;\n    flex-direction: column;\n    width: 400px;\n    height: 834px;\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    border: solid 1px #CCCCCC;\n\n}\n\n.external_chat_view_appear {\n    height: 834px;\n    border: solid 1px #CCCCCC;\n    animation-name: chat_view_showing;\n    animation-duration: 200ms;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in;\n}\n\n.chat_view_flag_icon {\n    width: 37px;\n    border: 1px solid #CCCCCC;\n}\n.chat_view_flag_select {\n    width: 37px;\n    display: inline-block;\n    cursor: pointer;\n    z-index: 30;\n}\n\n.chat_view_flag_list {\n    position: absolute;\n    top: 470px;\n    left: 8px;\n    list-style-type: none;\n    padding-left: 0px;\n    font-size: 15px;\n    background-color: transparent;\n}\n\n.flag_chat_view_flag_selectselect .flag_selected .flag_selected_value {\n    max-width: 90px;\n}\n\n.chat_view_flag_select ul {\n    width: 50px;\n    position: absolute;\n    background: #fff;\n    cursor: pointer;\n    padding: 0px;\n    border: 1px solid #CCC;\n}\n\n.chat_view_flag_select ul li {\n    display: flex;\n    align-items: center;\n    padding: 8px 5px;\n}\n\n.chat_view_flag_select ul li:hover {\n    background: rgba(168, 156, 235, 0.35)\n}\n\n@keyframes loading_bar_animation {\n    0% {\n        width: 0;\n        opacity: 1;\n    }\n\n    100% {\n        width: 100%;\n        opacity: 1;\n    }\n}\n\n@keyframes chat_view_showing {\n    from {\n        width: 0;\n        height: 0;\n        opacity: 0;\n    }\n\n    to {\n        width: 400px;\n        height: 834px;\n        opacity: 1;\n    }\n}\n\n@keyframes loading {\n    0% {\n        transform: scale(0);\n    }\n\n    50% {\n        transform: scale(1.0);\n    }\n\n    100% {\n        transform: scale(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
